import { useEffect, useState, useContext, useCallback  } from "react";
import { Card, Space, Image, notification, Col, Row  } from "antd";
import { useParams, useLocation } from "react-router-dom";
import { getMap, getVisuals } from "../API";
import ImgCalendar from "./calendar/imgcalendar";
import { Bar } from "react-chartjs-2";
import bgimage from '../images/monitor-back.png';

import ndviImage from '../images/generando-ndvi.gif';
import rgbImage  from '../images/generando-rgb.gif';



import {FarmerContext} from '../Helper/Context';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function Viewer() {
  const {farmerData, setFarmerData} = useContext(FarmerContext);
  
  //const [valueFromChild, setValueFromChild] = useState('');
  const [loadingVisuals, setLoadingVisuals] = useState(true);
  const [prevVisible, setPrevVisible] = useState(false);
  const [prevVisibleN, setPrevVisibleN] = useState(false);
  const { cropid } = useParams();
  const location = useLocation();
  const [Maprgb, setMaprgb] = useState(rgbImage);
  const [Mapndvi, setMapndvi] = useState(ndviImage);
  const [ImgDate, setImgDate] = useState();
  const [ndviVals, setndviVals] = useState({
    labels: [],
    datasets: [],
  });

  const handleValueChange = (value) => {
    //setValueFromChild(value);
    //getMap(cropid+'?date='+value).then((res) => {
    //  getTheMap(res);
    //});
    setLoadingVisuals(true);
    setMaprgb(rgbImage);
    setMapndvi(ndviImage);
    initViewer('?date='+value);
  };  

  const getTheMap=useCallback((res)=>{
      setFarmerData(res);
      setMaprgb('/api/crops/imagemap/'+res.maprgb);
      setMapndvi('/api/crops/imagemap/'+ res.mapndvi);
      setImgDate(res.imgDate);
  
      const labels = [
        "<0",
        "0-.1",
        ".1-.2",
        ".2-.3",
        ".3-.4",
        ".4-.5",
        ".5-.6",
        ".6-.7",
        ".7-.8",
        ".8-.9",
        ".9-1",
      ];
      const dataSource = {
        labels,
        datasets: [
          {
            label: "NDVI",
            data: res.ndvival,
            backgroundColor: "rgba(255, 0, 0, 1)",
          },
        ],
      };
      setndviVals(dataSource);
      setLoadingVisuals(false);
  },[setFarmerData]);

  const initViewer=useCallback((dir)=>{
    getMap(cropid+dir).then((res) => {
      if(res.status===0){
        notification.info({
          'message':'Imagenes no disponibles',
          'description': 'Generando imagenes'
        });

        getVisuals(cropid+'?date='+res.imgDate).then((resv)=>{          
          res.maprgb=resv.maprgb;
          res.mapndvi=resv.mapndvi;
          res.mapndwins=resv.mapndwins;
          
          getTheMap(res);

        });
      }else{
        getTheMap(res);
      }
    });     
  },[getTheMap,cropid]);

  useEffect(() => {
    if(!farmerData){
      initViewer(location.search);
    }else{
      getTheMap(farmerData);
    }
  }, [location, farmerData, getTheMap, initViewer]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Índice de vegetación NDVI",
      },
    },
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          padding: "20px",
        }}
      >
        Imagen satelital {ImgDate}
      </div>

      <Space
        size={20}
        direction="horizontal"
        align="top"
        style={{ padding: "20px" }}
      >
        <Space direction="horizontal">
          <Row>
          <Col span={8}>
          <Card style={{ minWidth: "320px" }}>
            <Image style={{width:"100%",minWidth: "150",minHeight:"86px",backgroundImage:"url("+bgimage+")"}}
              src={Maprgb}
              preview={
                {
                  mask:"Vista aumentada",
                  prevVisible,
                  scaleStep: 0.5,
                  src: Maprgb,
                  onVisibleChange: (value) => {setPrevVisible(value);},
                }
              }
            ></Image>
          </Card>            
          </Col>
          <Col span={8}>
          <Card style={{ minWidth: "320px" }}>
            <Image style={{width:"100%",minWidth: "150",minHeight:"86px",backgroundImage:"url("+bgimage+")"}}
              src={Mapndvi}
              preview={
                {
                  mask:"Vista aumentada",
                  prevVisibleN,
                  scaleStep: 0.5,
                  src: Mapndvi,
                  onVisibleChange: (value) => {setPrevVisibleN(value);},
                }
              }
            ></Image>

            <Bar options={options} data={ndviVals} />
          </Card>            
          </Col>
          <Col span={8}>
            {loadingVisuals?(
            <div style={{zIndex:9,backgroundColor:'rgba(0,0,0,0.5)',width:'100%', minHeight:'100%', position:'absolute'}}></div>
            ):''}
            <ImgCalendar onValueChange={handleValueChange}/>            
          </Col>
          </Row>

        </Space>
      </Space>
    </div>
  );
}

export default Viewer;